<template>
  <div class="dialog" v-if="visible">
    <div class="login-page">
      <div class="login-content">
        <div class="login-div" :style="`height:${divStyle.height}`">
          <div class="close" @click="closeDialog"><i class="el-icon-close"></i></div>
          <div class="login-type-tips">
            <div class="sanjx"></div>
            <div class="tips-content">{{loginType == 'pc' ? '扫码登录在这儿' : '密码登录在这儿'}}</div>
          </div>
          <div class="qrcode" v-if="isLogin">
            <img v-if="loginType === 'pc'" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/login/qrcode.png" alt="" @click="switchLogin('qr')" />
            <img v-if="loginType === 'qr'" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/login/pcode.png" alt="" @click="switchLogin('pc')" />
          </div>
          <Login v-if="loginType === 'pc'" :siteTitle.sync="siteTitle" :showType.sync="showType" @verifyCode="verifyCode" @backIndex="backIndex" @loginSuccess="loginSuccess" />
          <Qrcode v-else-if="loginType === 'qr'" :siteTitle.sync="siteTitle" :showType.sync="showType" @verifyCode="verifyCode" @backIndex="backIndex" @loginSuccess="loginSuccess" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Login from './components/account.vue';
import Qrcode from './components/code.vue';
 export default {
     props: {
        visible: Boolean,
        toUrl:String,
     },
       components: {
         Login,
         Qrcode
      },
      data() {
        return{
        divStyle: '',
        siteTitle: '扫码登录',
        isLogin: true,        // 是否登陆模式
        loginType: 'qr',      // 登录方式
        showType: 'login',
        // 扫码登录注册
         qrcode: null,
          loginInfo: null,
         }
      },
      mounted(){

      },
      methods:{
        //    登入成功
        loginSuccess(){
          if(this.toUrl){
            this.$router.push({path:this.toUrl})
          }else{
            this.$router.push({
							name: this.$indexPage,
						});
          }
        },
                // 切换登录类型
    switchLogin(type) {
      this.loginType = type;
      this.siteTitle = type === 'pc' ? '账号登录' : '扫码登录';
      this.backIndex();
    },

    verifyCode() {
      this.siteTitle = this.loginType === 'pc' ? '找回密码' : '微信注册';
      this.divStyle = {height: this.loginType === 'pc' ? '570px' : '670px', marginTop: this.loginType === 'pc' ? 'calc((100vh - 570px) / 2)' : 'calc((100vh - 670px) / 2)'};
      setTimeout(() => {
        this.showType = 'verify';
      }, 100);
    },

    backIndex() {
      this.siteTitle = this.loginType === 'pc' ? '账号登录' : '扫码登录';
      this.divStyle = {height: '520px', marginTop: 'calc((100vh - 520px) / 2)'};
      setTimeout(() => {
        this.showType = 'login'
      }, 100);
    },
         // 关闭
          closeDialog(){
            this.$emit('closeDialog')
          }
      }
    }
</script>
<style scoped lang="less">
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog__body {
  padding: 0;
}
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.close {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background: white;
  position: absolute;
  top: -12px;
  right: -12px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  i {
    width: 23px;
    height: 23px;
    border-radius: 25px;
    background-color: #999999;
    color: white;
    font-size: 18px;
    text-align: center;
    line-height: 23px;
  }
}
@import "login";
</style>